import { render, staticRenderFns } from "./TableLayout.vue?vue&type=template&id=6b89cdc8&scoped=true"
import script from "./TableLayout.vue?vue&type=script&lang=js"
export * from "./TableLayout.vue?vue&type=script&lang=js"
import style0 from "./TableLayout.vue?vue&type=style&index=0&id=6b89cdc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b89cdc8",
  null
  
)

export default component.exports